export function setAccessToken(AccessToken) {
  return new Promise((resolve) => {
    window.localStorage.setItem('accessToken', AccessToken);
    resolve()
  })
}
export function setUserTokenToken(AccessToken) {
  return new Promise((resolve) => {
    window.localStorage.setItem('userToken', AccessToken);
    resolve()
  })
}

export function removeAccessToken() {
  return new Promise((resolve) => {
    window.localStorage.removeItem('userInfo');
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('currentSystem');
    resolve()
  })
}

export function SetsessionStorage(name, value) {
  return new Promise((resolve) => {
    window.localStorage.setItem(name, value);
    resolve()
  })
}